export default function getHostname(url) {
  const urlRegex = /[^.]*\.[^.]{2,3}(?:\.[^.]{2,3})?$/gi;
  /*
      [0] - hostname (root). Ex. "haaretz.co.il" , "themarker.com"
    */
  const [ hostname, ] = urlRegex.exec(url) || [];

  return hostname;
}
